/* DeSiM 公式店 — FAQ ページ（カテゴリチップ + キーワード検索）。
   JS 無効でも各カテゴリの <details> はそのまま開閉できる（フォールバック）。
   このスクリプトは「見たい範囲を絞る」だけを担当する:
     - カテゴリチップ: クリックしたカテゴリの塊だけを表示し、検索欄はクリアする。
     - キーワード検索: 入力中は全カテゴリを横断し、質問文/回答文に部分一致する
       設問だけを表示する（一致 0 件のカテゴリ見出しごと隠す）。空にしたら
       直前に選んでいたカテゴリの表示へ戻す。 */
(function () {
  'use strict';
  var cats = document.querySelectorAll('[data-ds-faq-cat]');
  var chips = document.querySelectorAll('[data-ds-cat]');
  var search = document.querySelector('[data-ds-faq-search]');
  if (!cats.length) return;

  var activeCat = chips.length ? chips[0].getAttribute('data-ds-cat') : null;

  function showCategory(catId) {
    cats.forEach(function (cat) {
      cat.style.display = cat.getAttribute('data-ds-faq-cat') === catId ? '' : 'none';
      cat.querySelectorAll('[data-ds-faq-item]').forEach(function (item) {
        item.style.display = '';
      });
    });
    chips.forEach(function (chip) {
      chip.classList.toggle('is-active', chip.getAttribute('data-ds-cat') === catId);
    });
  }

  function runSearch(term) {
    var q = term.trim().toLowerCase();
    if (q === '') {
      showCategory(activeCat);
      return;
    }
    chips.forEach(function (chip) {
      chip.classList.remove('is-active');
    });
    cats.forEach(function (cat) {
      var anyVisible = false;
      cat.querySelectorAll('[data-ds-faq-item]').forEach(function (item) {
        var qText = item.querySelector('[data-ds-faq-q]');
        var aText = item.querySelector('[data-ds-faq-a]');
        var hay = (
          (qText ? qText.textContent : '') + (aText ? aText.textContent : '')
        ).toLowerCase();
        var match = hay.indexOf(q) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) anyVisible = true;
      });
      cat.style.display = anyVisible ? '' : 'none';
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      activeCat = chip.getAttribute('data-ds-cat');
      if (search) search.value = '';
      showCategory(activeCat);
    });
  });

  if (search) {
    search.addEventListener('input', function () {
      runSearch(search.value);
    });
  }

  showCategory(activeCat);
})();
